export default __webpack_public_path__ + "static/media/check.74aafa9f.svg";